// extracted by mini-css-extract-plugin
export var column = "footer-module--column--0b60c";
export var container = "footer-module--container--f1eb9";
export var footer = "footer-module--footer--a2fe4";
export var logo = "footer-module--logo--9ab9c";
export var logobox = "footer-module--logobox--ec33b";
export var row = "footer-module--row--702f1";
export var socials = "footer-module--socials--f1eeb";